<input [ngClass]="{'input-default': inputStyle === 'default', 'input-rounded': inputStyle === 'rounded'}"
       [ngStyle]="{'font-size': inputSize}" [type]="type" class="form-control" [placeholder]="placeholder">
